<template>
  <main class="gc-page">
    <section class="gc-hero contact-hero" :style="{ backgroundImage: `url(${heroImage})` }">
      <div class="gc-hero-content">
        <h1>联系</h1>
        <p>您的平台。您的社区。您的行动。</p>
      </div>
    </section>

    <section class="gc-section light-blue">
      <div class="gc-container contact-layout">
        <div class="contact-copy">
          <div class="gc-eyebrow">圣淘沙信息科技</div>
          <h2 class="gc-title">联系我们的支持团队！</h2>
          <p class="gc-copy">有问题、建议或合作想法？给我们留言，我们会尽快回复。</p>
        </div>
        <el-form class="contact-form" label-position="top" ref="form" :model="form" :rules="rules">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
          </el-form-item>

          <el-form-item label="电话" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入电话号码"></el-input>
          </el-form-item>

          <el-form-item label="邮箱" prop="email">
            <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
          </el-form-item>

          <el-form-item label="留言" prop="desc">
            <el-input type="textarea" :rows="5" v-model="form.desc" placeholder="请输入您的留言"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" class="submit-button" @click="submitForm">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </section>
  </main>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ContactView',
  data() {
    return {
      heroImage: 'https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/gy/Contact-Banner.jpg',
      form: {
        name: '',
        phone: '',
        email: '',
        desc: ''
      },
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入电话号码', trigger: 'blur' },
          { pattern: /^[0-9+\-\s()]{7,20}$/, message: '电话号码格式不正确', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '邮箱格式不正确', trigger: 'blur' }
        ],
        desc: [{ required: true, message: '请输入留言', trigger: 'blur' }]
      }
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(valid => {
        if (!valid) return

        try {
          axios.post(
            '/system/admin/submitFeedback',
            {
              feedbackTitle: this.form.name,
              contactNumber: this.form.phone,
              contactEmail: this.form.email,
              feedbackDescribe: this.form.desc
            },
            {
              headers: {
                AppTime: Date.now().toString(),
                AppTimestamp: Math.floor(Date.now() / 1000).toString()
              }
            }
          )

          this.$message.success('提交成功')
          this.$refs.form.resetFields()
        } catch (error) {
          this.$message.error('提交失败')
          console.error(error)
        }
      })
    }
  }
}
</script>

<style scoped>
.contact-hero::before {
  background: rgba(20, 127, 153, 0.6);
}

.contact-layout {
  display: grid;
  grid-template-columns: 0.85fr 1.15fr;
  gap: 70px;
  text-align: left;
  align-items: start;
}

.contact-form {
  background: #fff;
  border-radius: 6px;
  padding: 36px;
  box-shadow: 0 12px 34px rgba(18, 57, 74, 0.14);
}

/deep/ .el-form-item__label {
  color: #1765b2;
  font-size: 18px;
  font-weight: 900;
}

/deep/ .el-input__inner,
/deep/ .el-textarea__inner {
  border-radius: 5px;
  border: 1px solid rgba(23, 101, 178, 0.24);
  font-size: 16px;
}

/deep/ .el-input__inner {
  height: 54px;
}

.submit-button {
  min-width: 180px;
  height: 54px;
  border: 0;
  border-radius: 5px;
  background: #1765b2;
  font-size: 17px;
  font-weight: 900;
}

@media (max-width: 840px) {
  .contact-layout {
    grid-template-columns: 1fr;
  }

  .contact-form {
    padding: 28px;
  }
}
</style>
